import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TermsAndConditions = () => {

  const location = useLocation();

  useEffect(() => {
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((el) => el.remove());

    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  }, [location]);

  return (
    <div className="container mx-auto px-4 py-6 max-w-4xl">

      <h1 className="text-3xl font-bold mb-6 text-center">
        Terms and Conditions
      </h1>

      <ul className="list-disc ml-5 space-y-3 mb-8">
        <li>
          APM Smart Hub is a sub brand / business unit of APM Ecom Mart Private Limited,
          established in the year 2023.
        </li>
        <li>
          All our partnered outlets will have a registered GST number as per the business category.
        </li>
        <li>
          APM Smart Hub platform will never entertain any business without GST invoice.
        </li>
        <li>
          GST invoice provider <b>APM ECOM MART private limited/Vendor</b> will be solely responsible for the taxes levied by the government.
        </li>
        <li>
          GST invoice provider <b>APM ECOM MART private limited/Vendor</b> will be solely responsible for quality, warranty, guarantee,
          delivery, expiry, etc.
        </li>
        <li>
          We (APM Smart Hub / APM Ecom Mart Pvt Ltd) executives will never ask for
          Aadhaar, PAN, or any personal or financial details of customers.
        </li>
        <li>
          All registered customers are eligible for loyalty programs as per the mentioned rules.
        </li>
        <li>
          In some cases, loyalty points may get delayed due to server, network, or internet issues.
          We request customers to cooperate until the issue is resolved.
        </li>
        <li>
          A 10-digit Indian mobile phone number will be considered as the customer ID,
          which is non-transferable.
        </li>
        <li>
          Customers are advised to use the same single customer ID (10-digit Indian mobile number)
          for every purchase to enjoy lifetime benefits.
        </li>
        <li>
          APM Smart Hub reserves the right to change offers or loyalty program terms
          at any time without prior notice.
        </li>
        <li>
          Milestone gift vouchers will be provided only to eligible customers
          who satisfy the applicable terms and conditions.
        </li>
        <li>
          If a customer changes to a new mobile number (customer ID),
          previous purchase history will not be carried forward.
        </li>
        <li>
          The company reserves the right to amend or cancel any offer at any time
          without prior notice.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">
        Company Details
      </h2>

      <div className="mb-8 space-y-1">
        <p><strong>Legal Entity Name:</strong> APM ECOM MART PRIVATE LIMITED</p>
        <p><strong>CIN:</strong> U47912KA2023PTC171158</p>
        <p>
          <strong>Registered Address:</strong> No. 999/9, 2nd Floor, SSMB Plaza,
          5th A Cross, Outer Ring Road, Horamavu Service Road,
          Kalyan Nagar, Bangalore – 560043
        </p>
        <p><strong>Email:</strong> support@apmsmarthub.com</p>
        <p><strong>Phone:</strong> +91 94816 99771</p>
      </div>

      

    </div>
  );
};

export default TermsAndConditions;
